import Table from "../../../../core/common/dataTable/index";
import React, { useState } from "react";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { useUsersData } from "../hooks/useUsersData";
import PaginationControls from "../../../../core/common/pagination";
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "../../../router/all_routes";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import ActionsDropdown from "../../../../core/common/crmComponents/ActionsDropdown";
import { MODULES } from "../../../../core/data/constants/moduleConstants";
import { getAllUrlParams } from "../../../../utils/helpers/setAndGetUrlParams";
import { formatUsersData } from "../../../../utils/helpers/formatModulesData";
import { setFilterModel } from "../../../../core/data/redux/filterSlice";
import { convertToUTCString } from "../../../../utils/helpers/helper";
import { customMuiDateFilter } from "../../../../utils/helpers/customMuiDateFilter";

const UserList = ({ usersData }) => {
  const route = all_routes;

  const allParams = getAllUrlParams(); // Get all URL params
  const queryString = new URLSearchParams(allParams).toString();

  const filterModel = useSelector((state) => state.filter.filterModel);
  const dispatch = useDispatch();

  const processedRows = formatUsersData(usersData);

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      width: 70,
      renderCell: (params) => (
        <ActionsDropdown
          params={params}
          path={route.userDetails}
          module={MODULES.USERS}
        />
      ),
      sortable: false,
    },
    {
      field: "name",
      headerName: "Name",
      width: 120,
      sortable: true,
      renderCell: (params) => {
        const userDetailsUrl = `${route.userDetails.replace(
          ":id",
          params.row?.id
        )}?${queryString}`;
        return (
          <Link className="list-link text-capitalize" to={userDetailsUrl}>
            {params.row?.name}
          </Link>
        );
      },
    },
    {
      field: "role",
      headerName: "Role",
      width: 80,
      sortable: true,
      renderCell: (params) => (
        <div className="text-capitalize">
          {params?.row?.role?.split("-").join(" ")}
        </div>
      ),
    },

    { field: "email", headerName: "Email", width: 230, sortable: true },
    { field: "mobile", headerName: "Phone", width: 120, sortable: true },
    {
      field: "company",
      headerName: "Company",
      width: 120,
      sortable: true,
      renderCell: (params) => (
        <div className="text-capitalize">
          {params?.row?.ofCompany?.split("-").join(" ")}
        </div>
      ),
    },

    {
      field: "status",
      headerName: "Status",
      width: 90,
      sortable: true,
      renderCell: (params) => (
        <span
          className={`badge badge-pill badge-status ${
            params.row.status === "active" ? "bg-success" : "bg-danger"
          }`}
        >
          {params.row.status}
        </span>
      ),
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 210,
      valueFormatter: (params) =>
        params?.value ? convertToUTCString(params?.value) : "",
      filterOperators: customMuiDateFilter,
      renderCell: (params) => (
        <div>
          {params?.row?.createdAt
            ? convertToUTCString(params?.row?.createdAt)
            : convertToUTCString(params?.row?.updatedAt)}
        </div>
      ),
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      width: 210,
      valueFormatter: (params) =>
        params?.value ? convertToUTCString(params?.value) : "",
      filterOperators: customMuiDateFilter,
      renderCell: (params) => (
        <div>
          {params?.row?.updatedAt
            ? convertToUTCString(params?.row?.updatedAt)
            : convertToUTCString(params?.row?.createdAt)}
        </div>
      ),
    },
  ];

  return (
    <>
      <div>
        <DataGrid
          rows={processedRows}
          columns={columns.map((column) => ({
            ...column,
            headerClassName: "bg-light-200",
          }))}
          autoHeight
          hideFooter
          disableExtendRowFullWidth
          onStateChange={(state) => {
            const filteredRowIds = Object.entries(
              state.filter.filteredRowsLookup
            )
              .filter(([_, isVisible]) => isVisible === true)
              .map(([rowId]) => rowId); // Keep IDs as strings

            // Filter usersData based on these IDs
            const filteredData = usersData?.filter((row) =>
              filteredRowIds.includes(row?._id)
            );
            // Pass the filtered data to the parent
            // setFilteredData(filteredData);
          }}
          sx={{
            "& .sticky-column": {
              position: "sticky",
              right: 0,
              background: "white", // Prevents content from hiding under it
              zIndex: 100, // Keeps it on top
            },
            "& .MuiDataGrid-columnHeaders": {
              background: "white",
              position: "sticky",
              top: 0,
              zIndex: 110,
            },
            "& .MuiDataGrid-virtualScroller": {
              overflowX: "auto",
            },
          }}
          filterModel={filterModel}
          onFilterModelChange={(newModel) => dispatch(setFilterModel(newModel))}
          slots={{
            toolbar: GridToolbar, // Enable filter toolbar above the grid
          }}
          slotProps={{
            toolbar: {
              printOptions: { disableToolbarButton: true }, // Hide Print Button
              csvOptions: { disableToolbarButton: true }, // Hide CSV Export
            },
          }}
        />
      </div>
    </>
  );
};

export default UserList;
